// @flow
import { CERTIFICATION_TYPE_DISPLAY_NAMES } from '../../constants/affordableCertificationTypes';
import { determineCertTypeNameDefinitions } from '../GeneralAffordable/constants';

/**
 * Label for cert type in PIC transactions table / filters.
 * Uses program-specific definitions (e.g. HUD PH wording) when programName is set.
 */
export const getPicTransactionCertificationTypeDisplay = (
  certificationType: string,
  programName: ?string,
): string => {
  if (programName) {
    const certDefs = determineCertTypeNameDefinitions(programName);
    if (certDefs[certificationType]) {
      return certDefs[certificationType];
    }
  }
  return (
    CERTIFICATION_TYPE_DISPLAY_NAMES[certificationType] ?? certificationType
  );
};
